import { string, func, shape } from 'prop-types'

const newECPType = {
  address: shape({
    country: string,
    line1: string,
    line2: string,
    city: string,
    stateProvince: string,
    postalCode: string,
  }).isRequired,
  getNewECheckEUDDCallback: func.isRequired,
  modulus: string.isRequired,
  exponent: string.isRequired,
  submitTrigger: func,
  i18n: func.isRequired,
}

const newECPFormType = {
  getNewECheckEUDDFormCallback: func.isRequired,
  exponent: string,
  modulus: string,
}

export {
  newECPType,
  newECPFormType,
}
